import React from 'react';

const Audio = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <div className="flex items-center justify-center rounded-full bg-[rgba(27,31,77,0.40)] backdrop-blur-[8px]">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M9.87263 20.8061C8.98174 19.5677 8.45703 18.0482 8.45703 16.4061C8.45703 12.2403 11.8341 8.86328 15.9999 8.86328C20.1657 8.86328 23.5427 12.2403 23.5427 16.4061C23.5427 18.0482 23.018 19.5677 22.1271 20.8061"
          stroke="white"
          stroke-width="1.92"
          stroke-linecap="round"
        />
        <path
          d="M10.443 15.2499C11.3898 15.2499 12.1573 16.0174 12.1573 16.9642V21.7642C12.1573 22.711 11.3898 23.4785 10.443 23.4785H10.1002C7.82791 23.4785 5.98588 21.6365 5.98588 19.3642C5.98588 17.0919 7.82791 15.2499 10.1002 15.2499H10.443Z"
          fill="white"
          stroke="white"
          stroke-width="0.685714"
        />
        <path
          d="M21.8995 15.12C24.1717 15.12 26.0138 16.9621 26.0138 19.2343C26.0138 21.5066 24.1717 23.3486 21.8995 23.3486H21.5566C20.6098 23.3486 19.8423 22.5811 19.8423 21.6343V16.8343C19.8423 15.8875 20.6098 15.12 21.5566 15.12H21.8995Z"
          fill="white"
          stroke="white"
          stroke-width="0.685714"
        />
      </svg>
    </div>
  );
};

export default Audio;
